<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { KanbanLogItemInfo } from '@widgets/kanban-comments'
import { KANBAN_LOG_EMPTY_VALUE } from '@entities/kanban-comment'
import { useListsStore } from '@shared/model'
import { AppText } from '@shared/ui/typography'
import { IconContainer } from '@shared/ui/other'

defineOptions({
  name: 'TasksKanbanLogTaskType',
})

defineProps<{
  actor: KanbanLogActor | null
  oldValue: string | null
  value: string | null
}>()

const listsStore = useListsStore()
const taskTypeLabels = computed(() => listsStore.getTasksKanbanList?.task_type ?? {})
</script>

<template>
  <div class="kanban-log-field">
    <KanbanLogItemInfo
      :actor="actor"
      label="change task type"
    />
    <div class="kanban-log-field__row">
      <AppText
        v-if="oldValue"
        name="body2"
        color="slate-900"
      >
        {{ taskTypeLabels[oldValue] ?? oldValue }}
      </AppText>
      <AppText
        v-else
        name="body2"
        color="slate-400"
        class="unassigned"
      >
        {{ KANBAN_LOG_EMPTY_VALUE }}
      </AppText>
      <IconContainer>
        <FontAwesomeIcon :icon="faArrowRight" />
      </IconContainer>
      <AppText
        v-if="value"
        name="body2"
        color="slate-900"
      >
        {{ taskTypeLabels[value] ?? value }}
      </AppText>
      <AppText
        v-else
        name="body2"
        color="slate-400"
        class="unassigned"
      >
        {{ KANBAN_LOG_EMPTY_VALUE }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@shared/ui/kanban/styles/_kanban-log-field.scss" />
